export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">热门视频</h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">精选全网最火黑料视频，在线观看流畅高清，支持一键下载</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          <div className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-200">
            <div className="aspect-video relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20entertainment%20news%20video%20thumbnail%20with%20dark%20moody%20atmosphere%2C%20warm%20amber%20and%20deep%20crimson%20lighting%2C%20mysterious%20studio%20scene%20with%20spotlight%20effect%2C%20luxurious%20dark%20interior%2C%20dramatic%20cinematography%2C%20professional%20video%20production%20aesthetic%2C%20film%20noir%20style%2C%20high%20contrast&width=600&height=340&seq=media-01-2026&orientation=landscape"
                alt="独家爆料：娱乐圈最新黑料大盘点"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between">
                <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded">独家</span>
                <span className="px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded">15:42</span>
              </div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                </div>
              </div>
            </div>
            <div className="p-3 md:p-4">
              <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 mb-2 leading-snug">独家爆料：娱乐圈最新黑料大盘点，这些猛料你绝对没看过</h3>
              <div className="flex items-center gap-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1"><i className="ri-eye-line"></i>528.3万</span>
                <span className="flex items-center gap-1"><i className="ri-time-line"></i>刚刚更新</span>
              </div>
            </div>
          </div>

          <div className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-200">
            <div className="aspect-video relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20entertainment%20news%20video%20thumbnail%20with%20dark%20moody%20atmosphere%2C%20warm%20amber%20and%20deep%20crimson%20lighting%2C%20mysterious%20studio%20scene%20with%20spotlight%20effect%2C%20luxurious%20dark%20interior%2C%20dramatic%20cinematography%2C%20professional%20video%20production%20aesthetic%2C%20film%20noir%20style%2C%20high%20contrast&width=600&height=340&seq=media-02-2026&orientation=landscape"
                alt="网红圈大瓜合集"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between">
                <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded">热搜</span>
                <span className="px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded">22:18</span>
              </div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                </div>
              </div>
            </div>
            <div className="p-3 md:p-4">
              <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 mb-2 leading-snug">网红圈大瓜合集！最新黑料视频全网首发，速看速存</h3>
              <div className="flex items-center gap-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1"><i className="ri-eye-line"></i>416.7万</span>
                <span className="flex items-center gap-1"><i className="ri-time-line"></i>2小时前</span>
              </div>
            </div>
          </div>

          <div className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-200">
            <div className="aspect-video relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20entertainment%20news%20video%20thumbnail%20with%20dark%20moody%20atmosphere%2C%20warm%20amber%20and%20deep%20crimson%20lighting%2C%20mysterious%20studio%20scene%20with%20spotlight%20effect%2C%20luxurious%20dark%20interior%2C%20dramatic%20cinematography%2C%20professional%20video%20production%20aesthetic%2C%20film%20noir%20style%2C%20high%20contrast&width=600&height=340&seq=media-03-2026&orientation=landscape"
                alt="不为人知的真相深度揭秘"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between">
                <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded">深度</span>
                <span className="px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded">18:55</span>
              </div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                </div>
              </div>
            </div>
            <div className="p-3 md:p-4">
              <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 mb-2 leading-snug">不为人知的真相：黑料视频深度揭秘系列，持续更新中</h3>
              <div className="flex items-center gap-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1"><i className="ri-eye-line"></i>389.2万</span>
                <span className="flex items-center gap-1"><i className="ri-time-line"></i>5小时前</span>
              </div>
            </div>
          </div>

          <div className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-200">
            <div className="aspect-video relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20entertainment%20news%20video%20thumbnail%20with%20dark%20moody%20atmosphere%2C%20warm%20amber%20and%20deep%20crimson%20lighting%2C%20mysterious%20studio%20scene%20with%20spotlight%20effect%2C%20luxurious%20dark%20interior%2C%20dramatic%20cinematography%2C%20professional%20video%20production%20aesthetic%2C%20film%20noir%20style%2C%20high%20contrast&width=600&height=340&seq=media-04-2026&orientation=landscape"
                alt="2026年度重磅黑料合集"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between">
                <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded">年度</span>
                <span className="px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded">35:10</span>
              </div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                </div>
              </div>
            </div>
            <div className="p-3 md:p-4">
              <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 mb-2 leading-snug">2026年度重磅黑料合集 · 全网最高清在线观看与下载</h3>
              <div className="flex items-center gap-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1"><i className="ri-eye-line"></i>671.4万</span>
                <span className="flex items-center gap-1"><i className="ri-time-line"></i>8小时前</span>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-8">
          <a href="#" className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer transition-colors whitespace-nowrap">
            查看更多热门视频 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}